module.exports = __webpack_public_path__ + "img/client_logo_3.a9b36d5f.svg";